import React from 'react';
import { classList } from '../../../../../utils/string.ts';
import { Cookie } from '../../../../../utils/cookie.ts';

export type FooterStickyAdProps = {
  adId: string;
  minHeightClass?: string;
  className?: string;
  dataRef?: string;
  showClosingButton?: boolean;
};

export const FooterStickyAd: React.FunctionComponent<FooterStickyAdProps> = props => {
  const abTabSetup = new Cookie('sk-AB-tabsetup').value ?? 0;
  const adClassName = abTabSetup === '3' ? 'z-(--z-index-backdrop)' : 'z-(--z-index-modal-dialog)';

  return (
    <div className={classList('h5v-sticky-ad-container', props.className)} data-ref={props.dataRef}>
      <div id="sk_floorad" className={adClassName}></div>
      <div id="sk_mobile_stickyad" className={adClassName}></div>
      <button className="h5v-sticky-ad-close-button" data-ref="h5v-sticky-ad-close"></button>
    </div>
  );
};
